export const blockIconsImageTimer = (
	<span className='material-symbols-outlined'>timer</span>
);
